import { render, staticRenderFns } from "./featureAnalytics.vue?vue&type=template&id=2b0e0872&scoped=true&"
import script from "./featureAnalytics.vue?vue&type=script&lang=ts&"
export * from "./featureAnalytics.vue?vue&type=script&lang=ts&"
import style0 from "./featureAnalytics.vue?vue&type=style&index=0&id=2b0e0872&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0e0872",
  null
  
)

export default component.exports